// src/components/Banner.js
import React from "react";
import PropTypes from "prop-types";
import { Box, Typography, useTheme, useMediaQuery  } from "@mui/material";

const Banner = ({ title }) => {
    const theme = useTheme(); // Accede al tema
    const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // Verifica si el viewport es menor que "sm"
  return (
    <Box
      sx={{
        width: "100%",
        height: "auto",
        minHeight:"100px",
        position: "relative",
        background: "linear-gradient(135deg, #003366, #72CCF4)", // Fondo degradado
        color: "#FFFF",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden",
        borderRadius: isMobile? "0px": "8px",
        marginBottom: isMobile? "8px" : "16px",
      }}
    >
      <Typography
        sx={{
          fontSize: isMobile? "24px" : "32px",
          fontWeight: "bold",
          zIndex: 2,
          textAlign: "center",
        }}
      >
        {title}
      </Typography>
    </Box>
  );
};

Banner.propTypes = {
  title: PropTypes.string.isRequired,
};

export default Banner;
